import { isEmpty } from 'lodash';

export const filterSsuByStudyIdsAndSiteIds = (ssus, studyIds, siteIds) => {
  if (!isEmpty(studyIds) && !isEmpty(siteIds)) {
    return ssus
      .filter(ssu => siteIds.includes(ssu.site.uniqueIdentifier))
      .filter(ssu => studyIds.includes(ssu.study.uniqueIdentifier));
  }
  if (!isEmpty(studyIds) && isEmpty(siteIds)) {
    return ssus.filter(ssu => studyIds.includes(ssu.study.uniqueIdentifier));
  }
  if (isEmpty(studyIds) && !isEmpty(siteIds)) {
    return ssus.filter(ssu => siteIds.includes(ssu.site.uniqueIdentifier));
  }
  return ssus;
};
